export enum IdentStatus {
  pending = 0,
  success = 1,
  fail = 2,
  expired = 3,
  abandoned = 4,
}

export enum CardUsageStatus {
  unknown = 0,
  dormant = 1,
  used = 2,
  waiting = 3,
}

export enum WebIdTransactionProvider {
  WebID = 0,
  Onfido = 1,
  Veriff = 2,
  W2 = 3,
  None = 99,
}

export enum IdentLevel {
  Unknown  = 0,
  Sdd = 1,
  Fdd = 2,
  Edd = 3,
}

export enum AddressStatus {
  Unconfirmed = 0,
  WaitingForDocuments = 1,
  PendingCheck = 2,
  Confirmed = 5,
}

export enum GenderEnum {
  Unknown = 0,
  Male = 1,
  Female = 2,
  Other = 9,
}

export enum AddressChangeStatus {
  NoChange = 0,
  WaitingForDocuments = 1,
  PendingCheck = 2,
}


export enum AccountStatus {
  Ok = 0,
  DeletionRequested = 1,
  Deleted = 90,
}


export enum ReferralStatus {
  accpeted = 1,
  ordered = 2,
  pendingBonus = 3,
  completed = 4,
  expired = 9,
}

export enum CardConversionStatus {
  queued = 0,
  inProgress = 1,
  executed = 2,
  cancelled = 6,

  failed = 99,
}
